import ceiling from "./Ceiling";
import fixture from "./Fixture";
import space from "./Space";

export default {
    fixture,
    ceiling,
    space,
};
